import { html } from "lit";
var icon_theme_default = () => html`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <defs>
      <clipPath id="clip-path">
        <path
          d="M16.49 2h.37c4.62.58 7.69 2.68 9.22 5.66 1.13 2.19 1.18 4.67.54 5.29a11.52 11.52 0 0 1-2.06 1.23l-.45.22L23 15l-.57.27-.49.25c-2 1-2.83 1.94-2.72 3.44.22 2.52 2 3.52 4.66 3.58h1.22l1.14-.06v.08c-3.32 6.24-14.35 5.75-20.38.07a11.25 11.25 0 0 1 .02-16.98A14.8 14.8 0 0 1 16.49 2ZM4.54 4.17A13.24 13.24 0 0 0 4.42 24c7.21 6.8 20.77 7.08 24.06-1.79.37-1-.31-1.7-1.26-1.81h-.89l-1.33.09h-1.1c-1.79 0-2.6-.5-2.7-1.75 0-.28.2-.59.77-1l.27-.17.31-.19.36-.19.41-.21 1.68-.73.47-.23a12.34 12.34 0 0 0 2.5-1.53c1.47-1.4 1.41-4.8-.08-7.7C26.05 3.32 22.54.86 17.5.12l-.45-.06A16.76 16.76 0 0 0 4.54 4.17Z"
          fill="none" />
      </clipPath>
    </defs>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_2-2" data-name="Layer 2">
        <g clip-path="url(#clip-path)"><path d="M-1-1.33h31V30.4H-1z" /></g>
        <path
          d="M8.57 18.65a2.67 2.67 0 0 1-2.75-2.57 2.67 2.67 0 0 1 2.75-2.57 2.67 2.67 0 0 1 2.76 2.57 2.67 2.67 0 0 1-2.76 2.57Zm0-3.64a1.17 1.17 0 0 0-1.25 1.07 1.17 1.17 0 0 0 1.25 1.07 1.17 1.17 0 0 0 1.26-1.07A1.17 1.17 0 0 0 8.57 15Z" />
        <path
          d="M13.54 24.45a2.58 2.58 0 1 1 0-5.15 2.58 2.58 0 1 1 0 5.15Zm0-3.65a1.09 1.09 0 1 0 0 2.15 1.09 1.09 0 1 0 0-2.15Z" />
        <path
          d="M18.34 9.78a2.68 2.68 0 0 1-2.76-2.58 2.77 2.77 0 0 1 5.52 0 2.68 2.68 0 0 1-2.76 2.58Zm0-3.65a1.18 1.18 0 0 0-1.26 1.07 1.28 1.28 0 0 0 2.52 0 1.18 1.18 0 0 0-1.26-1.07Z" />
        <path
          d="M9.83 11.71a2.68 2.68 0 0 1-2.76-2.58 2.67 2.67 0 0 1 2.76-2.57 2.66 2.66 0 0 1 2.75 2.57 2.67 2.67 0 0 1-2.75 2.58Zm0-3.65a1.18 1.18 0 0 0-1.26 1.07 1.18 1.18 0 0 0 1.26 1.08 1.17 1.17 0 0 0 1.25-1.08 1.17 1.17 0 0 0-1.25-1.07Z" />
      </g>
    </g>
  </svg>
`;
export {
  icon_theme_default as default
};
//# sourceMappingURL=icon-theme.js.map
